import { render } from "./bell-off.vue?vue&type=template&id=5a1b92ac"
const script = {}
script.render = render

export default script